import { useQuery } from 'react-query';
import organizerRepository from 'modules/organizer/domain/repositories/organizer-repository';
import useIsDev from 'shared/hooks/use-is-dev';
import { Feature } from 'modules/organizer/domain/interfaces/available-feature';
import { useSelector } from 'react-redux';
import { authStoreUserTournamentId } from 'modules/auth/store/selectors';

interface useFetchAvailableFeatureProps {
  userTournamentId?: number;
}

export function useFetchAvailableFeature(props?: useFetchAvailableFeatureProps) {
  const { userTournamentId: extraUserTournamentId } = props ?? {};

  const isDev = useIsDev();
  const userTournamentId = useSelector(authStoreUserTournamentId) || extraUserTournamentId;

  const query = useQuery({
    queryKey: ['available-feature', userTournamentId],
    queryFn: () => {
      if (!userTournamentId) return Promise.resolve(null);
      return organizerRepository.fetchAvailableFeature(userTournamentId);
    },
    enabled: !!userTournamentId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  if (isDev) {
    return {
      ...query,
      data: {
        OBS_INTEGRATION: true,
        ACTIVE_CHAMPIONSHIPS: true,
        JOYSTICK: true,
        MEDIA_MANAGER: true,
      } as Feature,
    };
  }

  return query;
}
